import { all, takeEvery, put } from 'redux-saga/effects'
import actions from './actions'
import { signIn, signOut, changePassword } from '../../config/authRedirect'

export function* SIGNIN() {
  localStorage.removeItem('adminuser')
  signIn()
  yield put({
    type: 'user/SET_STATE',
  })
}

export function* SIGNOUT() {
  signOut()
  yield put({
    type: 'user/SET_STATE',
  })
}

export function* GETUSERNAME({ payload }) {
  const { name, authenticated } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      name,
      authenticated,
    },
  })
}

export function* SETUSERAUTHORIZATION({ payload }) {
  const { authorized } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      authorized,
    },
  })
}

export function* CHANGEPASSWORD() {
  changePassword()
  yield put({
    type: 'user/SET_STATE',
  })
}

export function* SETPAYMENTDATA({ payload }) {
  const { paymentData } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      paymentData,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SIGNIN, SIGNIN),
    takeEvery(actions.SIGNOUT, SIGNOUT),
    takeEvery(actions.GETUSERNAME, GETUSERNAME),
    takeEvery(actions.CHANGEPASSWORD, CHANGEPASSWORD),
    takeEvery(actions.SETUSERAUTHORIZATION, SETUSERAUTHORIZATION),
    takeEvery(actions.SETPAYMENTDATA, SETPAYMENTDATA),
  ])
}
